import React from 'react';
import RequestPasswordResetForm from '../components/RequestPasswordResetForm';

export const RequestPasswordReset = () => {
  return <RequestPasswordResetForm />;
};
